"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCTAList = fetchCTAList;
exports.fetchCTA = fetchCTA;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var BASE_URL = '/ctas/v3/placements';

function fetchCTAList() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var searchTerm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var portalId = _hubspot.default.get();

  return _apiClient.default.get(BASE_URL, {
    query: {
      portalId: portalId,
      offset: offset,
      limit: limit,
      name__contains: searchTerm
    }
  });
}

function fetchCTA(guid) {
  var portalId = _hubspot.default.get();

  return _apiClient.default.get(BASE_URL + "/" + guid, {
    portalId: portalId
  });
}